import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AuthUserSchema } from '../types/AuthUser'
import { IUser } from '../../../User'
import { AUTH_USER_LS_KEY } from '../constants/constants'
import { logoutUser } from '../services/logoutUser'
import { fetchAuthUser } from '../services/fetchAuthUser'

const userFromLocal = localStorage.getItem(AUTH_USER_LS_KEY)

const initialState: AuthUserSchema = {
	isLoading: false,
	error: '',
	authUser: userFromLocal ? JSON.parse(userFromLocal) : undefined
}

const authUserSlice = createSlice({
	name: 'authUser',
	initialState,
	reducers: {
		setAuthData: (state, action: PayloadAction<IUser>) => {
			state.authUser = action.payload
		},
		initAuthData: (state) => {
			const user = localStorage.getItem(AUTH_USER_LS_KEY)
			if (user) {
				state.authUser = JSON.parse(user)
			}
		},
		logout: (state) => {
			state.authUser = undefined
			localStorage.removeItem(AUTH_USER_LS_KEY)
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(logoutUser.fulfilled, (state) => {
				state.authUser = undefined
			})
			.addCase(fetchAuthUser.pending, (state) => {
				state.isLoading = true
				state.error = ''
			})
			.addCase(fetchAuthUser.fulfilled, (state, action) => {
				state.isLoading = false
				state.authUser = action.payload
			})
			.addCase(fetchAuthUser.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload ?? ''
			})
	}
})

export const { actions: authUserActions } = authUserSlice
export const { reducer: authUserReducer } = authUserSlice
